import { render, staticRenderFns } from "./CardPaymentsRates.vue?vue&type=template&id=2a997b90&"
import script from "./CardPaymentsRates.vue?vue&type=script&lang=js&"
export * from "./CardPaymentsRates.vue?vue&type=script&lang=js&"
import style0 from "./CardPaymentsRates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports